import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_SEEN_MUTATION = graphql(`
  mutation EditMessageThreadSeen($id: ID!, $isSeen: Boolean!) {
    editMessageThread(id: $id, input: { isSeen: $isSeen }) {
      id
      isSeen
      type
      ...MessageThread
    }
  }
`);

export default EDIT_MESSAGE_THREAD_SEEN_MUTATION;
